export enum VehicleStatus {
  MOVING = 'MOVING',
  NOT_MOVING = 'NOT_MOVING',
  OFFLINE = 'OFFLINE',
  ENGINE_ON = 'ENGINE_ON',
  MOVING_WARNING = 'MOVING_WARNING',
  NOT_MOVING_WARNING = 'NOT_MOVING_WARNING',
  OFFLINE_WARNING = 'OFFLINE_WARNING',
  ENGINE_ON_WARNING = 'ENGINE_ON_WARNING',
  IDLE = 'IDLE',
  TABLET_POSITION = 'TABLET_POSITION',
  TABLET_POSITION_WARNING = 'TABLET_POSITION_WARNING',
  LOADING_UNLOADING_DELAY = 'LOADING_UNLOADING_DELAY'
}

export enum VehicleStatusColor {
  MOVING = '#00A65A',
  WARNING = '#B63019',
  ENGINE_ON = '#F79A17',
  IDLE = '#AA47BC',
  NOT_MOVING = '#5683C8',
  OFFLINE = '#8E8E8E',
  TABLET_POSITION = '#78909C',
}

export enum VehicleMarkerBackgroundColor {
  ONLINE = '#FFFFFF',
  OFFLINE = '#d1d1d1',
}
